const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

const Shopify = window.Shopify;

export class CustomerAddresses {
  constructor() {

    if (window.customerAddresses) {
      return window.customerAddresses
    }

    setTimeout(() => {
      this._initialize()
    }, 100)
  }

  _initialize() {
    this.elements = this._getElements();

    if (Object.keys(this.elements).length === 0) {
      setTimeout(() => {
        this._initialize()
      }, 500)
      return;
    }

    this._setupCountries();
    this._setupEventListeners();

    window.customerAddresses = this;
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: container.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    const currentValue = target.getAttribute(attributes.expanded)
    const newValue = (currentValue === "false").toString()

    target.setAttribute(attributes.expanded, newValue)
    target.setAttribute("data-expanded", newValue)
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    const addressContainer = currentTarget.closest("[data-address]")
    const toggleButton = addressContainer ? addressContainer.querySelector(`[${attributes.expanded}]`) : null
    if (toggleButton) {
      this._toggleExpanded(toggleButton)
    }
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}

window.onload = () => {
  typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
}
